<div class="row">
  <div class="col-12 col-md-6">
    <div class="row mb-4">
      <div class="col-12 mb-4 d-flex flex-row justify-content-between">
        <h1 class="mt-0 mb-0">{{ 'CUSTOMER_INFORMATION' | translate }}</h1>
      </div>
      <div class="col-12 mb-3">
        <lib-gung-text-input
          [(ngModel)]="checkout.extra.oh.kundbestnr"
          gungTranslate="CUSTOMER_ORDER_NO"
        ></lib-gung-text-input>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-select-option-input
          [optionsList]="customerContactsOptions"
          [(ngModel)]="checkout.extra.oh.ftgkontaktnr"
          gungTranslate="CONTACT_NO"
          extraHostClass="mb-0"
        ></lib-gung-select-option-input>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-text-input
          [(ngModel)]="checkout.extra.oh.kundref2"
          gungTranslate="CUSTOMER_REF"
        ></lib-gung-text-input>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-text-input
          gungTranslate="ORDER_CONFIRMATION_EMAIL"
          type="text"
          name="orderConfirmEmail"
          id="orderConfirmEmail"
          [(ngModel)]="checkout.extra._msFlowOrderConfirmEmail"
        /><label class="text-danger" for="orderConfirmEmail">{{ 'MANDATORY_FIELD' | translate }}</label>
        <span class="text-error" *ngIf="orderConfirmError">{{ 'BAD_EMAIL' | translate }}</span>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-text-input
          gungTranslate="TRACK_AND_TRACE_EMAIL"
          type="text"
          name="trackAndTraceEmail"
          id="trackAndTraceEmail"
          [(ngModel)]="checkout.extra.oh.q_hl_emailtt"
        />
        <span class="text-error" *ngIf="trackAndTraceError">{{ 'BAD_EMAIL' | translate }}</span>
      </div>

      <div class="col-12 mb-3">
        <lib-meta-select-input
          [(ngModel)]="checkout.extra.oh.ordertextkod"
          gungTranslate="ORDER_SPECIFIC_TEXT"
          table="xotx"
          metaId="ordertextkod"
          metaDisplay="ordertextkodbeskr"
          [disabled]="!useOrderSpecificTextDropdown"
        ></lib-meta-select-input>
      </div>
      <div class="col-12 mb-3">
        <lib-gung-select-option-input
          [optionsList]="customerSpecificTextOptions"
          [(ngModel)]="checkout.extra.oh.kundtextkod"
          gungTranslate="CUSTOMER_SPECIFIC_TEXT"
          extraHostClass="mb-0"
        ></lib-gung-select-option-input>
        <!-- <lib-meta-select-input
          [(ngModel)]="checkout.extra.oh.kundtextkod"
          gungTranslate="CUSTOMER_SPECIFIC_TEXT"
          table="xktx"
          metaId="kundtextkod"
          metaDisplay="kundtextkodbeskr"
        ></lib-meta-select-input>-->
      </div>
      <div class="col-12 mb-3">
        <lib-gung-text-input
          [(ngModel)]="checkout.extra.oh.q_hl_crmprojectno"
          gungTranslate="CRM_PROJECT_NO"
        ></lib-gung-text-input>
      </div>

      <div class="col-12 mb-3">
        <lib-meta-select-input
          [(ngModel)]="checkout.extra.oh.salestype"
          gungTranslate="SALES_TYPE"
          table="xsal"
          metaId="salestype"
          metaDisplay="salestypedescr"
          [optionsSortFunctionFullRecord]="sortMetaDataByCode"
        ></lib-meta-select-input>
        <label class="text-danger">{{ 'MANDATORY_FIELD' | translate }}</label>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-text-area-input
          [(ngModel)]="checkout.extra.oh.editext"
          gungTranslate="EXTERNAL_TEXT"
        ></lib-gung-text-area-input>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-6">
    <div class="row mb-4">
      <div class="col-12 mb-4 d-flex flex-row justify-content-between">
        <h1 class="mt-0 mb-0">{{ 'SHIPPING_INFORMATION' | translate }}</h1>
        <gung-button classes="btn btn-primary" label="CREATE_POD" [onClick]="createPOD.bind(this)" />
      </div>
      <div class="col-12 mb-3">
        <lib-gung-input-multi-select
          label="DELIVERY_LOCATION"
          [optionsList]="pointOfDeliveryOptions"
          [(ngModel)]="checkout.extra.oh.ordlevplats1"
          (selectedValues)="$event?.length > 0 ? selectDeliveryAddress($event[0]) : undefined"
          [showId]="false"
          [previewField]="['name', ' - ', 'ftgpostadr1', ', ', 'ftgpostadr2', ', ', 'ftgpostnr', ' ', 'ftgpostadr3']"
          singleSelection="true"
          [showEmptyIds]="true"
        ></lib-gung-input-multi-select>
      </div>

      <div class="col-12 mb-3">
        <lib-meta-select-input
          [(ngModel)]="checkout.extra.oh.transportorskod"
          (ngModelChange)="onCarrierChanged($event)"
          gungTranslate="CARRIER_CODE"
          table="x2t"
          metaId="transportorskod"
          metaDisplay="transportorsnamn"
          [extraInputClass]="showCarrierWarning || showDeliveryInstructionWarning ? 'highlight-input' : ''"
        ></lib-meta-select-input>
      </div>
      <div class="col-12" *ngIf="showCarrierWarning">
        <small class="text-danger">
          <i class="fas fa-exclamation-triangle"></i>
          {{ 'CARRIER_REQUIRES_CONTACT_DETAILS_WARNING' | translate }}
        </small>
      </div>
      <div class="col-12" *ngIf="showDeliveryInstructionWarning">
        <small class="text-danger">
          <i class="fas fa-exclamation-triangle"></i>
          {{ 'CARRIER_REQUIRES_DELIVERY_INSTRUCTION_WARNING' | translate }}
        </small>
      </div>

      <div class="col-12 mb-3">
        <lib-meta-select-input
          [(ngModel)]="checkout.extra.oh.q_guarantid"
          gungTranslate="GUARANT_DESCRIPTION"
          table="q_guarant"
          metaId="q_guarantid"
          metaDisplay="q_guarantdescr"
        ></lib-meta-select-input>
      </div>

      <div class="col-12 mb-3 row">
        <div class="col-9">
          @if (!!deliveryDateOption) {
          <div class="form-check radio-button-container">
            <lib-gung-radio-button-input-horizontal
              [(ngModel)]="deliveryDateOption"
              [buttonValue]="'N'"
              [radioGroupName]="'deliveryDateOptions'"
              (ngModelChange)="onDeliveryDateOptionChanged($event)"
              gungTranslate="NONE"
            >
            </lib-gung-radio-button-input-horizontal>
          </div>
          <div class="form-check radio-button-container">
            <lib-gung-radio-button-input-horizontal
              [(ngModel)]="deliveryDateOption"
              [buttonValue]="'FIXED'"
              [radioGroupName]="'deliveryDateOptions'"
              (ngModelChange)="onDeliveryDateOptionChanged($event)"
              gungTranslate="FIXED_DELIVERY_DATE"
            >
            </lib-gung-radio-button-input-horizontal>
          </div>
          <div class="form-check radio-button-container">
            <lib-gung-radio-button-input-horizontal
              [(ngModel)]="deliveryDateOption"
              [buttonValue]="'EARLIER'"
              [radioGroupName]="'deliveryDateOptions'"
              (ngModelChange)="onDeliveryDateOptionChanged($event)"
              gungTranslate="EARLIER_DESPATCH_OK"
            >
            </lib-gung-radio-button-input-horizontal>
          </div>
          }

          <div class="form-check radio-button-container">
            <div class="form-group row">
              <label for="inlineCheckbox2" class="col-form-label col-12 col-sm-4">
                {{ 'CHARGE_FREIGHT_COST' | translate }}
              </label>
              <div class="col d-flex align-items-center justify-content-center form-check-big">
                <input
                  type="checkbox"
                  id="inlineCheckbox2"
                  class="form-check-input"
                  [checked]="checkout.extra.oh.kundfraktdeb"
                  (change)="checkout.extra.oh.kundfraktdeb = !checkout.extra.oh.kundfraktdeb"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="col-12 mb-4 d-flex flex-row justify-content-end">
            <gung-button
              classes="btn btn-primary"
              label="TRANSPORT_DETAILS"
              [onClick]="editTransportDetails.bind(this)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12 mb-4 d-flex flex-row justify-content-between">
        <h1 class="mt-0 mb-0">{{ 'WAREHOUSE_INFORMATION' | translate }}</h1>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-text-input
          [(ngModel)]="checkout.extra.oh.godsmarke2"
          gungTranslate="GOODS_LABEL_ROW_2"
        ></lib-gung-text-input>
      </div>

      <div class="col-12 mb-3">
        <lib-meta-select-input
          [(ngModel)]="checkout.extra.oh.levvillkkod"
          gungTranslate="DISPATCH_METHOD"
          table="x2e"
          metaId="levvillkkod"
          metaDisplay="levvillkbeskr"
        ></lib-meta-select-input>
      </div>

      <div class="col-12 mb-3">
        <lib-meta-select-input
          [(ngModel)]="checkout.extra.oh.dellevtillaten"
          gungTranslate="PARTIAL_DELIVERY_ALLOWED"
          table="xdl"
          metaId="dellevtillaten"
          metaDisplay="dellevtillatenbeskr"
        ></lib-meta-select-input>
      </div>
      <div class="col-12 mb-3">
        <lib-meta-select-input
          table="x2f"
          metaId="levsattkod"
          metaDisplay="levsattbeskr"
          [(ngModel)]="checkout.extra.oh.levsattkod"
        ></lib-meta-select-input>
      </div>
      <div class="col-12 mb-3">
        <lib-gung-text-area-input
          [(ngModel)]="checkout.extra.oh.editplblob"
          gungTranslate="TEXT_ON_PICKING_LIST"
        ></lib-gung-text-area-input>
      </div>
    </div>
  </div>
</div>
